function toggleActiveMenu(menuButton) {
  const isActive = menuButton.classList.contains(
    "header-digitalks__menu-btn--active"
  );
  const menu = document.querySelector(".menu-digitalks");

  if (!isActive) {
    menuButton.classList.add("header-digitalks__menu-btn--active");
    menu.classList.add("menu-digitalks--active");
    return;
  }

  menuButton.classList.remove("header-digitalks__menu-btn--active");
  menu.classList.remove("menu-digitalks--active");
}

function listenMenuClick() {
  const menuButton = document.querySelector(".header-digitalks__menu-btn");
  menuButton &&
    menuButton.addEventListener("click", () => toggleActiveMenu(menuButton));
}

async function addHasSubmenuClass() {
  const subMenus = document.querySelectorAll(".sub-menu");
  function isThirdLevel(element) {
    return (
      element.parentElement.classList.contains("menu-item") &&
      element.parentElement.parentElement.classList.contains("sub-menu")
    );
  }
  subMenus.forEach((subMenu) => {
    if (isThirdLevel(subMenu)) {
      subMenu.classList.add("panel");
      subMenu.parentElement.addEventListener("click", () => {
        subMenu.parentElement.classList.toggle("actived");
        const panel = subMenu.parentElement.querySelector(".panel");
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
      subMenu.parentElement.classList.add("has-submenu");
      // subMenu.parentElement.querySelector("a").removeAttribute("href");
      subMenu.parentElement.querySelector("a").href = "javascript:void(0)"; // SEO improve
      subMenu.parentElement.querySelector("a").title = "Colapsar"; // SEO improve
    }
  });
}

function distributeSpaceEvenly() {
  const screenWidth = window.screen.width;
  if (screenWidth >= 920) {
    const columns = document.querySelector("#menu-digitalks").children;
    const width = `${100 / columns.length}%`;
    Array.from(columns).forEach((column) => (column.style.width = width));
  }
}

function attributeTitleMain() {
  const anchorsWithoutTitle = document.querySelectorAll("#menu-digitalks a:not([title])");
  Array.from(anchorsWithoutTitle).forEach(anchor => anchor.title = `Ir para ${anchor.innerText}`);
}

function attributeTitleFooter() {
  const anchorsWithoutTitle = document.querySelectorAll(".footer li.menu-item a:not([title])");
  Array.from(anchorsWithoutTitle).forEach(anchor => anchor.title = `Ir para ${anchor.innerText}`);
}

window.addEventListener("load", () => {
  listenMenuClick();
  addHasSubmenuClass();
  distributeSpaceEvenly();
  attributeTitleMain();
  attributeTitleFooter();
});
